export default "__VITE_ASSET__DxzoYs8B__"